import errorsFactory from "../errorsFactory.js"
/* eslint-disable */
export default {
	async get({ tenantId }) {
		return import(/* webpackChunkName: "settings" */ `@/clientSettings/${tenantId}.js`)
			.then(settings => {
				return Promise.resolve({ data: settings.default })
			})
			.catch(err => {
				return import(/* webpackChunkName: "settings" */ `@/clientSettings/demo_uat.js`)
					.then(settings => {
						return Promise.resolve({ data: settings.default })
					})
					.catch(e => {
						return Promise.resolve(errorsFactory({ code: "missing_settigns" }))
					})
			})
	}
}
